module.exports = "https://img1.huilianyi.com/3/icon_wechat.350325fd13.appcore.png";